/**
 * All AngularX components that needs to be downgraded for use in AngularJS
 * should be done here.
 */
import { downgradeComponent } from '@angular/upgrade/static';

import { app } from "@app/v1_integration/definitions";
import { AppComponent } from '@app/app.component';

//Downgrade Angular components to AngularJS
app.directive(
  'idp2App', 
  downgradeComponent({ component: AppComponent })
);

